import { defineAsyncComponent } from 'vue'

export default {
    routes: [
        {
            path: '/pbxware',
            name: 'pbxware.index',
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'PBXWare',
                icon: 'fal fa-phone-office fa-fw',
                permission: 'manage-pbxware',
                module: 'metatech/pbxware',
                auth: true,
            },
            children: [
                {
                    path: 'servers/:serverId',
                    name: 'pbxware.server.show',
                    component: () => import('./views/server/Show.vue'),
                    meta: {
                        label: 'Server',
                        permission: 'manage-pbxware',
                    },
                    children: [
                        {
                            path: 'tenants/:tenantId',
                            name: 'pbxware.tenant.show',
                            component: () => import('./views/server/tenant/Show.vue'),
                            meta: {
                                label: 'Tenant',
                                permission: 'manage-pbxware',
                            },
                            children: [
                                {
                                    path: 'cdr',
                                    name: 'pbxware.tenant.cdr.index',
                                    component: () => import('./views/server/tenant/cdr/Index.vue'),
                                    meta: {
                                        label: 'CDR',
                                        icon: 'fal fa-cabinet-filing fa-fw',
                                        permission: 'manage-pbxware',
                                    },
                                },
                                {
                                    path: 'did',
                                    name: 'pbxware.tenant.did.index',
                                    component: () => import('./views/server/tenant/did/Index.vue'),
                                    meta: {
                                        label: 'DID',
                                        icon: 'fal fa-id-badge fa-fw',
                                        permission: 'manage-pbxware',
                                    },
                                },
                                {
                                    path: 'extensions',
                                    name: 'pbxware.tenant.extension.index',
                                    component: () =>
                                        import('./views/server/tenant/extension/Index.vue'),
                                    meta: {
                                        label: 'Extensions',
                                        icon: 'fal fa-phone-rotary fa-fw',
                                        permission: 'manage-pbxware',
                                    },
                                },
                                {
                                    path: 'ivr',
                                    name: 'pbxware.tenant.ivr.index',
                                    component: () => import('./views/server/tenant/ivr/Index.vue'),
                                    meta: {
                                        label: 'IVR',
                                        icon: 'fal fa-microphone fa-fw',
                                        permission: 'manage-pbxware',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
}
